import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { faCircleInfo, faHourglassHalf, faMemoCircleInfo } from '@fortawesome/pro-light-svg-icons';
import { ShiveGridWrapperComponent } from '../../../../shared/components/shive-controls/shive-grid/shive-grid-wrapper.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SubSink } from 'subsink';
import { UserOperation } from '../../../../core/enums/user-operation';
import { ShiveRoutes } from '../../../../core/routing/segments/route-segments';
import { combineLatest, of } from 'rxjs';
import { UserModel } from '../../../../core/models/user/user.model';
import { filter, switchMap, take } from 'rxjs/operators';
import { UsersHttpService } from '../../../../core/state/users/users-http.service';
import { TimetableEntry } from '../timetable-types';
import { assert } from '../../../../core/assert/assert';
import { TimeBlockHttpService } from '../../../../core/state/time-blocks/time-block-entries/time-block-http.service';
import { TimetableService } from '../timetable.service';
import { TimeFormatType } from '../../../../core/pipes/time-format.pipe';
import { TimeBlockContentType } from '../../../../features/calendar/components/time-block/types/time-block-types';

@Component({
  selector: 'app-timetable-overview',
  templateUrl: './timetable-overview.component.html',
  standalone: false,
})
export class TimetableOverviewComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('gridWrapperComponent') gridWrapperComponent: ShiveGridWrapperComponent;
  public timetableEntries = signal<TimetableEntry[]>([]);
  public readonly faCircleInfo = faCircleInfo;
  public readonly UserOperation = UserOperation;
  public readonly TimeFormatType = TimeFormatType;
  private readonly router = inject(Router);
  private readonly usersHttpService = inject(UsersHttpService);
  private readonly route = inject(ActivatedRoute);
  private readonly timetableService = inject(TimetableService);
  private readonly timeBlockHttpService = inject(TimeBlockHttpService);
  private readonly subs = new SubSink();
  private selectedYear: number;

  ngOnInit(): void {
    // Subscribe to year changes
    this.subs.sink = this.timetableService.yearChanged$
      .pipe(filter((selectedYear) => selectedYear !== null))
      .subscribe((selectedYear: number) => {
        this.selectedYear = selectedYear;
        this.loadGridData();
      });
  }

  ngAfterViewInit(): void {
    this.initContextMenuCallbacks();
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  public loadGridData(): void {
    this.usersHttpService
      .getUsers(false)
      .pipe(
        take(1),
        switchMap((users: UserModel[]) => {
          const start = new Date(this.selectedYear, 0, 1);
          const end = new Date(this.selectedYear, 11, 31, 23, 59, 59);
          const userIds = users.map((user) => user.id);
          const timeBlockContentTypes = [
            TimeBlockContentType.Project,
            TimeBlockContentType.Absence,
          ];
          return combineLatest([
            this.timeBlockHttpService.fetchTimeBlocks(
              start,
              end,
              userIds,
              null,
              null,
              timeBlockContentTypes,
            ),
            of(users),
          ]);
        }),
      )
      .subscribe(([data, users]) => {
        assert(data.length === users.length);
        // const result = data.map((item, index) => {
        //   // todo group here
        //   // return this.timetableOverviewService.createTimetableOverviewEntry(users[index], item);
        // });
        // this.timetableEntries.set(result);
      });
  }

  private initContextMenuCallbacks(): void {
    this.gridWrapperComponent.contextMenuItems = [
      {
        text: 'Monatsauswertung',
        faIcon: faMemoCircleInfo,
        callback: () => {
          void this.router.navigate([ShiveRoutes.ReportsTimetableMonthly, '3'], {
            relativeTo: this.route,
          });
        },
        isVisible: true,
        isActivated: true,
      },
      {
        text: 'Zeiteinträge',
        faIcon: faHourglassHalf,
        callback: () => {
          void this.router.navigate([ShiveRoutes.ReportsTimetableTimeEntries, '3'], {
            relativeTo: this.route,
          });
        },
        isVisible: true,
        isActivated: true,
      },
    ];
  }
}
